import { useRef, useState, useEffect } from "react";
import {
  IonModal,
  IonContent,
  IonHeader,
  IonToolbar,
  IonRadioGroup,
  IonRadio,
} from "@ionic/react";
import { actions } from "../../Redux/store";
import { useSelector } from "react-redux";
import { hapticsImpactLight } from "../../lib/utils";
import { useLeagueStore } from "../../zustandStore/leagueStore";

export default function ScoringFormatModal() {
  const modal = useRef<HTMLIonModalElement>(null);
  const isOpen = useSelector(
    (sate: any) => sate.modal.scoringFormatModal?.open,
  );
  
  // Get scoring format state and methods from league store
  const { ScoringFormat, setScoringFormat } = useLeagueStore();
  
  const closeScoringFormatModal = () => {
    actions.modal.closeScoringFormatModal(null);
  };

  function dismiss() {
    modal.current?.dismiss();
    closeScoringFormatModal();
  }

  const leagueType = [
    {
      leagueId: 1,
      name: "PPR",
    },
    {
      leagueId: 2,
      name: "Half-PPR",
    },
    {
      leagueId: 3,
      name: "Standard (Non-PPR)",
    },
  ];
  
  const [selectedLeagueId, setSelectedLeagueId] = useState<any>(ScoringFormat?.leagueId);

  // Update local state when store value changes
  useEffect(() => {
    setSelectedLeagueId(ScoringFormat?.leagueId);
  }, [ScoringFormat]);

  const handleRadioChange = (event: any) => {
    const clickedLeagueId = event.target.value;
    hapticsImpactLight();

    setSelectedLeagueId(clickedLeagueId);
  };

  const handleCardClick = (leagueCard: any) => {
    hapticsImpactLight();

    setSelectedLeagueId(leagueCard?.leagueId);
  };

  const handleContinue = () => {
    if (selectedLeagueId) {
      const selectedFormat = leagueType.find(format => format.leagueId === selectedLeagueId);
      if (selectedFormat) {
        setScoringFormat(selectedFormat);
        hapticsImpactLight();
        dismiss();
      }
    }
  };

  return (
    <IonModal
      expandToScroll={false}
      onDidDismiss={dismiss}
      className="league-selection-modal"
      isOpen={isOpen}
      backdropDismiss={true}
      initialBreakpoint={0.45}
      breakpoints={[0, 0.45]}
      ref={modal}
    >
      <IonHeader className="ion-no-border modal-ion-header">
        <IonToolbar className="custom-toolbar">
          <div className="flex items-center justify-center w-full px-4 pt-8">
            <span className="text-white text-[20px] font-medium leading-[140%] text-center">
              Select scoring format
            </span>
          </div>
        </IonToolbar>
      </IonHeader>

      <div className="flex flex-col h-full">
        <IonContent scrollY className="flex-1 overflow-y-auto">
          <div className="px-[12px]">
            <IonRadioGroup
              value={selectedLeagueId}
              onIonChange={handleRadioChange}
            >
              <div className="flex-col justify-center pt-4 pb-6  cursor-pointer">
                {leagueType.map((leagueCard: any, index: any) => (
                  <div
                    key={index}
                    className={`flex items-center justify-between w-full p-3 cursor-pointer`}
                    onClick={() => handleCardClick(leagueCard)}
                  >
                    <div className="flex-col space-y-[2px]">
                      <p className={`text-white text-[16px] font-medium `}>
                        {leagueCard?.name}
                      </p>
                    </div>
                    <div className={`h-full flex items-center justify-center `}>
                      <IonRadio
                        class="custom-radio"
                        mode="md"
                        value={leagueCard?.leagueId}
                        aria-label="Custom checkbox"
                      ></IonRadio>
                    </div>
                  </div>
                ))}
              </div>
            </IonRadioGroup>
          </div>
        </IonContent>

        <div
          className="pt-4 bg-[#000513] flex flex-col items-center"
          style={{
            paddingBottom: "calc(env(safe-area-inset-bottom) + 20px)",
          }}
        >
          <button 
            className={`w-[280px] h-[48px] flex justify-center items-center rounded-[50px] mt-3 ${
              selectedLeagueId 
                ? 'bg-white text-black' 
                : 'bg-white/15 text-white'
            }`}
            onClick={handleContinue}
            disabled={!selectedLeagueId}
          >
            <span className="text-[12px] font-medium">Continue</span>
          </button>
        </div>
      </div>
    </IonModal>
  );
}
